import {
  AlarmUpdatesDTO,
  DataVersion,
  ReducedAlarm,
} from '@hakimo-ui/hakimo/types';
import {
  BasicPanel,
  QueryResult,
  Timeline,
} from '@hakimo-ui/hakimo/ui-elements';
import { eventTracker, useCanAddAlarmComment } from '@hakimo-ui/hakimo/util';
import { Alert, Button, Tooltip } from '@hakimo-ui/shared/ui-base';
import { ChatBubbleBottomCenterTextIcon } from '@heroicons/react/24/solid';
import { useState } from 'react';
import { UseQueryResult } from 'react-query';
import { getUpdateEvents } from '../../shared/components/alarm-updates/util';
import RegularAlarmUpdates from './RegularAlarmUpdates';
import SharedAlarmUpdates from './SharedAlarmUpdates';
import { CommentModal } from './comment-modal/CommentModal';
interface Props {
  alarm: ReducedAlarm;
  sharedToken?: string;
  dataVersion?: DataVersion;
}

export function AlarmUpdates(props: Props) {
  const { alarm, sharedToken, dataVersion } = props;
  const [open, setOpen] = useState(false);
  const canComment = useCanAddAlarmComment();

  const addComment = canComment ? (
    <div className="mr-6">
      <Tooltip text="Add comment" position="left">
        <Button
          variant="icon"
          onClick={() => setOpen(true)}
          onSideEffect={eventTracker('open_add_alarm_comment_modal')}
        >
          <ChatBubbleBottomCenterTextIcon className="w-5" />
        </Button>
      </Tooltip>
    </div>
  ) : null;

  const renderContent = (
    queryResult: UseQueryResult<AlarmUpdatesDTO, Error>
  ) => {
    return (
      <QueryResult queryResult={queryResult}>
        {(data) => {
          const events = getUpdateEvents(data);

          return (
            <div className="max-h-[30rem] overflow-auto px-6">
              {events.length > 0 ? (
                <Timeline events={events} />
              ) : (
                <div className="pt-4">
                  <Alert>No updates</Alert>
                </div>
              )}
              {open && (
                <CommentModal
                  open={true}
                  onClose={() => setOpen(false)}
                  alarm={alarm}
                  dataVersion={dataVersion}
                />
              )}
            </div>
          );
        }}
      </QueryResult>
    );
  };

  return (
    <BasicPanel title="Alarm Updates" secondary={addComment}>
      {sharedToken ? (
        <SharedAlarmUpdates sharedToken={sharedToken}>
          {renderContent}
        </SharedAlarmUpdates>
      ) : (
        <RegularAlarmUpdates
          alarmId={alarm.id}
          timestamp={alarm.timestamp}
          dataVersion={dataVersion}
        >
          {renderContent}
        </RegularAlarmUpdates>
      )}
    </BasicPanel>
  );
}

export default AlarmUpdates;
